import { render, staticRenderFns } from "./adminrole.vue?vue&type=template&id=b9d6da36&scoped=true&"
import script from "./adminrole.vue?vue&type=script&lang=js&"
export * from "./adminrole.vue?vue&type=script&lang=js&"
import style0 from "./adminrole.vue?vue&type=style&index=0&id=b9d6da36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d6da36",
  null
  
)

export default component.exports